


import React, { useEffect, useState } from 'react'
import NormalTable from '../../../../Component/NormalTable'
import { Grid, Typography } from '@mui/material';
import { masterAPI } from '../../../Masters/dataConfig';
import { axiosPrivate } from '../../../../axios/axios';
import { color } from '../../../../StyleData/Config';

const TransationHistory = ({info}) => {
    const [data,setData]=useState([])
    const[reciptData, setReciptData] = useState([])

    useEffect(()=>{
        getData()
    },[])

    const getData=async()=>{
      const link = masterAPI["issueReturn"].getbyissuereturnlistbypartid;
     await axiosPrivate
        .get(`${link}/${info.partId}`)
        .then((res) => {
          console.log(res.data, "issueRetun Data");
        
          setData(res.data.result);
        })
        .catch((e) => {
          console.log(e, "allinven");
         
          setData([])
        });
          const linkrec = masterAPI["receipt"].getbyreceiptitemlistbypartid;
        await axiosPrivate
        .get(`${linkrec}/${info.partId}`)
        .then((res) => {
          console.log(res.data, "recipt Data");
        
          setReciptData(res.data.result);
        })
        .catch((e) => {
          console.log(e, "allinven");
         
          setReciptData([])
        });
      }

    const columns = [
    //    {
    //     Header:"Code",
    //     accessor:"code"
    //    },
       {
        Header:"Stock Room",
        accessor:"stockRoomName"
       },
        {
            Header: "Aisle",
            accessor: "aisleName",
            Cell:({cell})=>{
              return (
                  <Typography sx={{fontSize:"inherit",fontWeight:"inherit",color:"inherit"}}>{cell.row.original.aisleCode+" - "+cell.value}</Typography>
              )
            }
            // disableFilters: true,
          },
          {
            Header: "Row",
            accessor: "rowName",
            Cell:({cell})=>{
              return (
                  <Typography sx={{fontSize:"inherit",fontWeight:"inherit",color:"inherit"}}>{cell.row.original.rowCode+" - "+cell.value}</Typography>
              )
            }
            // disableFilters: true,
          },
          {
            Header: "Bin",
            accessor: "binName",
            Cell:({cell})=>{
              return (
                  <Typography sx={{fontSize:"inherit",fontWeight:"inherit",color:"inherit"}}>{cell.row.original.binCode+" - "+cell.value}</Typography>
              )
            }
            // disableFilters: true,
          },
          
          {
            Header: "Quantity",
            accessor: "quantity",
          },
       
      ];
const columnsRecipt = [
    //    {
    //     Header:"Code",
    //     accessor:"code"
    //    },
       {
        Header:"Stock Room",
        accessor:"stockRoomName"
       },
        {
            Header: "Aisle",
            accessor: "aisleName",
            Cell:({cell})=>{
              return (
                  <Typography sx={{fontSize:"inherit",fontWeight:"inherit",color:"inherit"}}>{cell.row.original.aisleCode+" - "+cell.value}</Typography>
              )
            }
            // disableFilters: true,
          },
          {
            Header: "Row",
            accessor: "rowName",
            Cell:({cell})=>{
              return (
                  <Typography sx={{fontSize:"inherit",fontWeight:"inherit",color:"inherit"}}>{cell.row.original.rowCode+" - "+cell.value}</Typography>
              )
            }
            // disableFilters: true,
          },
          {
            Header: "Bin",
            accessor: "binName",
            Cell:({cell})=>{
              return (
                  <Typography sx={{fontSize:"inherit",fontWeight:"inherit",color:"inherit"}}>{cell.row.original.binCode+" - "+cell.value}</Typography>
              )
            }
            // disableFilters: true,
          },
          
          {
            Header: "Received Quantity",
            accessor: "receivedQuantity",//inventoryQuantity
          },
               {
            Header: "Inventory Quantity",
            accessor: "inventoryQuantity",//inventoryQuantity
          },
           {
            Header: "Unit Price",
            accessor: "unitPrice",
          },
       
       
      ];
  return (
    <Grid>
   <Typography
              sx={{
                // color: color.masterDialogTitleColor,
                // fontSize: color.masterDialogFontSize,
                fontSize: color.AssetTitlesize,
                fontWeight: color.sideFontWeightAsset,
              }}
            >Issue Return Transaction History</Typography>
     <NormalTable data={data} columns={columns} />
        <Typography
              sx={{
                // color: color.masterDialogTitleColor,
                // fontSize: color.masterDialogFontSize,
                fontSize: color.AssetTitlesize,
                fontWeight: color.sideFontWeightAsset,
              }}
            >Receipt Items Transaction History</Typography>
     <NormalTable data={reciptData} columns={columnsRecipt} />
     </Grid>
  )
}

export default TransationHistory